var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import qrcodeGenerator from 'qrcode-generator';
var rect = 'v1h1v-1z';
function makePath(qrcode, margin, reverse) {
    var moduleCount = qrcode.getModuleCount();
    var d = '';
    for (var row = 0; row < moduleCount; row++) {
        for (var col = 0; col < moduleCount; col++) {
            if (qrcode.isDark(row, col) === (reverse ? false : true)) {
                d += "M".concat(col + margin, ",").concat(row + margin).concat(rect);
            }
        }
    }
    return d;
}
var QrSvg = function QrSvg(_a) {
    var _b = _a.bgColor, bgColor = _b === void 0 ? '#fff' : _b, cellClassPrefix = _a.cellClassPrefix, _c = _a.fgColor, fgColor = _c === void 0 ? '#000' : _c, _d = _a.level, level = _d === void 0 ? 'L' : _d, _e = _a.margin, margin = _e === void 0 ? 0 : _e, _f = _a.type, type = _f === void 0 ? 0 : _f, _g = _a.value, value = _g === void 0 ? '' : _g, otherProps = __rest(_a, ["bgColor", "cellClassPrefix", "fgColor", "level", "margin", "type", "value"]);
    var qrcode = useMemo(function () {
        var qrcode = qrcodeGenerator(type, level);
        qrcode.addData(value);
        qrcode.make();
        return qrcode;
    }, [level, type, value]);
    var size = qrcode.getModuleCount() + margin * 2;
    var bgPath = makePath(qrcode, margin, true);
    var fgPath = makePath(qrcode, margin);
    var bgClassName = cellClassPrefix && "".concat(cellClassPrefix, " ").concat(cellClassPrefix, "-empty");
    var fgClassName = cellClassPrefix && "".concat(cellClassPrefix, " ").concat(cellClassPrefix, "-filled");
    return (React.createElement("svg", __assign({ shapeRendering: "crispEdges", viewBox: "0 0 ".concat(size, " ").concat(size) }, otherProps),
        React.createElement("path", { d: bgPath, fill: bgColor, className: bgClassName }),
        React.createElement("path", { d: fgPath, fill: fgColor, className: fgClassName })));
};
QrSvg.propTypes = {
    bgColor: PropTypes.string,
    cellClassPrefix: PropTypes.string,
    fgColor: PropTypes.string,
    level: PropTypes.oneOf(['L', 'M', 'Q', 'H']),
    margin: PropTypes.number,
    type: PropTypes.oneOf([
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
        26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
    ]),
    value: PropTypes.string.isRequired,
};
export default QrSvg;
